/**
 * Mock CV Analysis Data for Onboarding Process
 */

import type { CertificateItem, RoleItem, SkillItem } from '../types/OnboardingTypes';

export const mockSkills: SkillItem[] = [
    // Soft Skills
    {
        id: 1,
        name: 'Kommunikation',
        category: 'Soft Skills',
        level: 4 as const,
        status: 'pending',
        type: 'skill',
        source: 'ai',
    },
    {
        id: 2,
        name: 'Teamarbeit',
        category: 'Soft Skills',
        level: 3 as const,
        status: 'pending',
        type: 'skill',
        source: 'ai',
    },
    {
        id: 3,
        name: 'Problemlösung',
        category: 'Soft Skills',
        level: 4 as const,
        status: 'pending',
        type: 'skill',
        source: 'ai',
    },
    {
        id: 4,
        name: 'Führungsqualitäten',
        category: 'Soft Skills',
        level: 2 as const,
        status: 'pending',
        type: 'skill',
        source: 'ai',
    },
    // Hard Skills
    {
        id: 5,
        name: 'React.js',
        category: 'Hard Skills',
        level: 4 as const,
        status: 'pending',
        type: 'skill',
        source: 'ai',
    },
    {
        id: 6,
        name: 'TypeScript',
        category: 'Hard Skills',
        level: 3 as const,
        status: 'pending',
        type: 'skill',
        source: 'ai',
    },
    {
        id: 7,
        name: 'Node.js',
        category: 'Hard Skills',
        level: 3 as const,
        status: 'pending',
        type: 'skill',
        source: 'ai',
    },
    {
        id: 8,
        name: 'Python',
        category: 'Hard Skills',
        level: 2 as const,
        status: 'pending',
        type: 'skill',
        source: 'ai',
    },
    // Industry Skills
    {
        id: 9,
        name: 'Agile Methoden',
        category: 'Industry Skills',
        level: 3 as const,
        status: 'pending',
        type: 'skill',
        source: 'ai',
    },
    {
        id: 10,
        name: 'DevOps',
        category: 'Industry Skills',
        level: 2 as const,
        status: 'pending',
        type: 'skill',
        source: 'ai',
    },
    {
        id: 11,
        name: 'Cloud Computing',
        category: 'Industry Skills',
        level: 3 as const,
        status: 'pending',
        type: 'skill',
        source: 'ai',
    },
    {
        id: 12,
        name: 'Projektmanagement',
        category: 'Industry Skills',
        level: 2 as const,
        status: 'pending',
        type: 'skill',
        source: 'ai',
    },
];

export const mockCertificates: CertificateItem[] = [
    {
        id: 101,
        name: 'AWS Certified Solutions Architect',
        status: 'pending',
        source: 'ai',
    },
    {
        id: 102,
        name: 'Certified Scrum Master (CSM)',
        status: 'pending',
        source: 'ai',
    },
];

export const mockRoles: RoleItem[] = [
    {
        id: 201,
        name: 'Senior Frontend Developer',
        status: 'pending',
        source: 'ai',
    },
    {
        id: 202,
        name: 'Full Stack Developer',
        status: 'pending',
        source: 'ai',
    },
];

export const mockDescription = `Erfahrener Full-Stack-Entwickler mit über 5 Jahren Expertise in modernen Web-Technologien. Spezialisiert auf React, TypeScript und Node.js.`;

export const mockAnalysisResults = {
    skills: mockSkills,
    certificates: mockCertificates,
    roles: mockRoles,
    description: mockDescription,
};
